import React, { memo, useCallback, useMemo } from 'react'
import { Form, Formik } from 'formik'
import type { OAuthClient } from 'src/interfaces/oauth'
import { OAuthClientFormContent } from './OAuthClientFormContent'
import { oauthClientFormValidator } from './OAuthClientForm.validator'
import { toFormValues } from './OAuthClientForm.mapper'
import type { OAuthClientFormValues } from './OAuthClientForm.interface'

interface Props {
  client: OAuthClient | null
  isReadOnly: boolean
  isSaving: boolean
  onSubmit(values: OAuthClientFormValues): void
  onDirtyChange(isDirty: boolean): void
}

const OAuthClientFormComponent = ({
  client,
  isReadOnly,
  isSaving,
  onSubmit,
  onDirtyChange,
}: Props) => {
  const initialValues = useMemo(() => {
    return toFormValues(client)
  }, [client])

  const handleSubmit = useCallback(
    (values: OAuthClientFormValues) => {
      onSubmit(values)
    },
    [onSubmit],
  )

  return (
    <Formik<OAuthClientFormValues>
      initialValues={initialValues}
      validationSchema={oauthClientFormValidator}
      onSubmit={handleSubmit}
      // Reinitialises from the saved client after every successful save, which is what returns
      // `dirty` to false and re-enables the status bar's Enable/Disable button.
      enableReinitialize
    >
      <Form>
        <OAuthClientFormContent
          mode={client === null ? 'create' : 'manage'}
          isReadOnly={isReadOnly}
          isSaving={isSaving}
          onDirtyChange={onDirtyChange}
        />
      </Form>
    </Formik>
  )
}

export const OAuthClientForm = memo(OAuthClientFormComponent)
